import styled from 'styled-components';

export const PickedStockCardsContainer = styled.div`
    display: grid;
    gap: 20px 0;
    width: 100%;
    max-height: calc(100vh - 338px);
    overflow-y: scroll;
    padding-bottom: 20px;
    ${({ theme }) => `
        ${theme.breakpoints.down('sm')} {
            >:last-child {
                margin-bottom: 86px;
            }
        }
    `}
`;
